'use client';

import React, { FC, useEffect, useState } from 'react';
import styles from './MapSection.module.scss';
// import { NearbyStoresData } from '@/src/app/(root)/contact-us/Types/types';
// import { fetchNearestStores } from '@/src/app/(root)/contact-us/services/storeService';
import DealersMap from './DealersMap/DealersMap';
import Loader from '../../ui/Loader/Loader';
import Overlay from './Overlay/Overlay';
// import { Mode, Store } from './Types/types';
// import { BASE_URL } from '../../../../contstants/baseUrl';
import InfoSectionMobile from './Overlay/InfoSectionMobile';
import { useMediaQuery } from 'usehooks-ts';
import request from '../../../../utils/request.js';
import { filterExactPostcodeMatches } from '../../../../utils/postcode';

const NearestDealerSection = ({ fields, rendering }) => {
  let initialNearbyStoresData = {
    userInfo: {
      countryCode: '',
      provinceCode: '',
      cityCode: '',
      address: '',
      extendedField2: '',
      location: {
        lat: 0,
        lng: 0,
      },
    },
    nearbyStores: [],
  };
  let initialPostalData = {
    postcodeInfo: {
      country: '',
      id: 0,
      latitude: '',
      longitude: '',
      postCode: '',
      siteName: '',
    },
    nearbyStores: [],
  };

  const [mode, setMode] = useState('SEARCH');

  const [postcode, setPostcode] = useState('');
  const [postcodeError, setPostcodeError] = useState(false);

  const [storesData, setStoresData] = useState(initialNearbyStoresData);
  const [postalData, setPostalData] = useState(initialPostalData);
  const [selectedStore, setSelectedStore] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [storesByCountry, setStoresByCountry] = useState(initialNearbyStoresData);
  const mobile = useMediaQuery('(max-width: 400px)');

  const fetchLocations = async (inputText) => {
    if (!inputText) {
      setPostcodeError(false);
      setPostalData(initialPostalData);
      return;
    }

    try {
      // 邮编模糊搜索：支持部分邮编匹�?
      // const result = fields.stores.filter((store) => {
      //   const postcode = store.fields.postalCode?.value || '';
      //   const searchText = inputText.toLowerCase();

      //   // 检查邮编（部分匹配�?
      //   return postcode.toLowerCase().includes(searchText);
      // });
      const validateBody = {
        postcode: inputText,
      };
      const validateRes = await request.post('/api/sitecore/store/Validate', validateBody);
      if (validateRes?.code === 200 && validateRes?.data) {
        setPostcodeError(false);
        const nearestStoreBody = {
          root: rendering?.dataSource,
          postcode: inputText,
        };
        const nearestStoreRes = await request.post(
          '/api/sitecore/store/NearestStore',
          nearestStoreBody
        );
        if (nearestStoreRes?.code === 200 && nearestStoreRes?.data) {
          // 绝对匹配优先：有 postcode 完全匹配的只保留匹配项，否则显示接口返回的全部
          const data = nearestStoreRes.data;
          setPostalData({
            ...data,
            nearbyStores: filterExactPostcodeMatches(data.nearbyStores, inputText),
          });
        } else {
          setPostcodeError(true);
        }
      } else {
        setPostcodeError(true);
      }

      // if (result && result.length > 0) {
      //   // 有结果：正常显示
      //   setStoresData({ userInfo: result[0].fields, nearbyStores: result });
      // } else {
      //   // 无结果：静默处理，不显示特殊提示
      //   setStoresData({
      //     userInfo: initialNearbyStoresData.userInfo,
      //     nearbyStores: [],
      //   });
      // }
    } catch (error) {
      setStoresData(initialNearbyStoresData);
    }
  };

  useEffect(() => {
    const fetchStoresByCountry = async () => {
      try {
        setIsLoading(true);
        // const response = await fetch(`${BASE_URL}/api/store/storesByCountry`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        // });
        // if (!response.ok) {
        //   throw new Error('Failed to fetch stores by country');
        // }
        const stores = fields?.stores;

        if (!stores || stores.length <= 0) {
          throw new Error('Failed to fetch stores by country');
        }
        // const data = await response.json();
        setStoresData((prevData) => ({
          ...prevData,
          nearbyStores: stores,
          // nearbyStores: data.address.stores,
        }));
        setStoresByCountry((prevData) => ({
          ...prevData,
          // nearbyStores: data.address.stores,
          nearbyStores: stores,
        }));
        setIsLoading(false);
      } catch (error) {}
    };

    setIsLoading(true);
    fetchStoresByCountry();
  }, []);

  useEffect(() => {
    if (selectedStore) {
      setMode('INFO');
    }
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [selectedStore]);

  const handleSearch = () => {
    if (!postcode) return;
    setMode('INFO');
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleStart = () => {
    setMode('SEARCH');
    setSelectedStore(null);
    setStoresData(storesByCountry);
    setPostcode('');
    setPostcodeError(false);
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleBack = () => {
    setMode('INFO');
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleContact = () => {
    setMode('CONTACT');
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className={'container'}>
      <div className={styles.content}>
        <div className={styles.mapWrapper}>
          <DealersMap
            stores={storesData.nearbyStores}
            postalData={postalData}
            userInfo={storesData.userInfo}
            selectedStoreCode={selectedStore}
            setSelectedStoreCode={setSelectedStore}
            centerLat={fields?.centerLat?.value}
            centerLon={fields?.centerLon?.value}
          />

          <Overlay
            mode={mode}
            postcode={postcode}
            onChangePostcode={setPostcode}
            onSearch={handleSearch}
            onBack={handleBack}
            onStart={handleStart}
            onContact={handleContact}
            selectedStore={selectedStore}
            fetchLocations={fetchLocations}
            setMode={setMode}
            mobile={mobile}
            fields={fields} // 传�?fields 参数
            postcodeError={postcodeError}
          />

          {mode === 'INFO' && selectedStore && mobile && (
            <div className={styles.overlayMobile}>
              <InfoSectionMobile
                selectedStore={selectedStore}
                onStart={handleStart}
                onContact={handleContact}
                fields={fields}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NearestDealerSection;
